import { Point } from '../math/geometry';
import { RelativeFloatingPort } from '../layout/core/relativeFloatingPort';
export class ClusterBoundaryPort extends RelativeFloatingPort {
    get LoosePolyline() {
        return this.loosePolyline;
    }
    set LoosePolyline(value) {
        this.loosePolyline = value;
    }
    // constructor
    constructor(curveDelegate, centerDelegate, locationOffset = new Point(0, 0)) {
        super(curveDelegate, centerDelegate, locationOffset);
    }
    // constructor
    static mk(curveDelegate, centerDelegate) {
        return new ClusterBoundaryPort(curveDelegate, centerDelegate);
    }
}
//# sourceMappingURL=ClusterBoundaryPort.js.map